import { useTranslation } from 'react-i18next';
import React from 'react';
import { useLanguage } from '../../../core/i18n/hooks/use-language';
import { useAuthenticatedFormQuery } from '../hooks/use-authenticated-form-query';
import { useAuthenticatedSendFormRequest } from '../hooks/use-authenticated-form-request';
import { AuthenticatedFormType } from '../types';
import { usePathBuilder } from '../../../core/routing/hooks/use-path-builder';
import { FormLayout } from './form-layout';

type Props = {
  formType: AuthenticatedFormType;
  documentTitle: string;
  hintText?: string;
  queryParam?: Record<string, string | number | null>;
  linkBackTo?: { to: string; label: string };
};

export const AuthenticatedForm: React.FC<Props> = ({ hintText, formType, documentTitle, queryParam, linkBackTo }) => {
  const { t } = useTranslation();
  const currentLanguage = useLanguage();
  const { homePath } = usePathBuilder();

  const { data: fields, isLoading: isLoadingFields } = useAuthenticatedFormQuery(formType, queryParam);
  const { mutateAsync: sendFormRequest, isPending: isPendingFormRequest } =
    useAuthenticatedSendFormRequest(currentLanguage);

  return (
    <FormLayout
      documentTitle={documentTitle}
      fields={fields?.data.fields ?? []}
      formType={formType}
      hintText={hintText}
      isLoadingFields={isLoadingFields}
      isPendingFormRequest={isPendingFormRequest}
      linkBackTo={linkBackTo ?? { to: homePath(), label: t('global.backToHome') }}
      sendFormRequest={sendFormRequest}
    />
  );
};
